/**
 * CRDTService - CRDT同期処理を管理
 */

import * as Y from 'yjs'
import type { AppState } from '../types'

export class CRDTService {
  private ydoc: Y.Doc
  private ymap: Y.Map<unknown>

  constructor() {
    this.ydoc = new Y.Doc()
    this.ymap = this.ydoc.getMap('appState')
  }

  /**
   * CRDTへの同期
   */
  syncToCRDT(state: AppState): void {
    this.ydoc.transact(() => {
      this.ymap.set('appState', state)
    })
  }

  /**
   * CRDTからの同期
   */
  syncFromCRDT(): AppState | undefined {
    return this.ymap.get('appState') as AppState | undefined
  }

  /**
   * CRDT同期の監視を設定
   */
  observeChanges(callback: () => void): void {
    this.ymap.observe(callback)
  }

  /**
   * CRDT状態のエンコード
   */
  encodeState(): Uint8Array {
    return Y.encodeStateAsUpdate(this.ydoc)
  }

  /**
   * CRDT状態のデコード
   */
  applyUpdate(update: Uint8Array): void {
    Y.applyUpdate(this.ydoc, update)
  }

  /**
   * クリーンアップ
   */
  clear(): void {
    this.ymap.clear()
  }
}